import { CalendarDays } from "lucide-react";
import { Label } from "@/components/ui/label";

const reflectionPeriods = [
  ["daily", "Daily"],
  ["weekly", "Weekly"],
  ["monthly", "Monthly"],
];

export const ReflectionSettings = ({ average, period, reflectionDate, onDateChange, onPeriodChange }) => (
  <section className="grid gap-4 rounded-2xl border border-[#E5E1D8] bg-white p-5 shadow-[0_8px_30px_rgba(26,54,38,0.04)] lg:grid-cols-[1.25fr_1fr_auto] sm:p-6" data-testid="reflection-settings-section">
    <div data-testid="reflection-period-field">
      <Label className="text-[#1A3626]">Rhythm</Label>
      <div className="mt-2 flex rounded-full border border-[#E5E1D8] bg-[#F9F6F0] p-1" data-testid="reflection-period-toggle">
        {reflectionPeriods.map(([value, label]) => (
          <button key={value} type="button" onClick={() => onPeriodChange(value)} data-testid={`reflection-period-${value}-button`} className={`flex-1 rounded-full px-4 py-2 text-sm font-medium transition-colors duration-300 ${period === value ? "bg-[#C87961] text-white" : "text-[#4A5D4E] hover:bg-white"}`}>{label}</button>
        ))}
      </div>
    </div>
    <div data-testid="reflection-date-field">
      <Label htmlFor="reflection-date" className="text-[#1A3626]">Reflection date</Label>
      <div className="mt-2 flex h-11 items-center gap-2 rounded-xl border border-[#E5E1D8] bg-[#F9F6F0] px-3 text-[#4A5D4E]">
        <CalendarDays size={17} />
        <input id="reflection-date" data-testid="reflection-date-input" type="date" value={reflectionDate} onChange={(event) => onDateChange(event.target.value)} required className="w-full bg-transparent text-sm text-[#1A3626] outline-none" />
      </div>
    </div>
    <div className="rounded-xl bg-[#1A3626] px-5 py-4 text-white" data-testid="reflection-average-card">
      <p className="text-xs uppercase tracking-[0.2em] text-white/70" data-testid="reflection-average-label">Average</p>
      <p className="font-serif-display text-3xl font-semibold" data-testid="reflection-average-value">{average}</p>
    </div>
  </section>
);